// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface LearningDate
 */
export interface LearningDate {
    /**
     * 
     * @type {Date}
     * @memberof LearningDate
     */
    startedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof LearningDate
     */
    finishedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof LearningDate
     */
    status: LearningDateStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LearningDateStatusEnum {
    Learning = 'learning',
    Pause = 'pause',
    Success = 'success',
    Fail = 'fail',
    Abort = 'abort'
}



